import { stockData } from './Helpers';

export default {
  series: 1,
  data: stockData,
};
